import { ref } from 'vue'
import { API_BASE_URL } from '../config.js'

const isApiAvailable = ref(true)
const lastErrorTime = ref(null)
const errorType = ref(null)

export function useApiStatus() {
  const setApiUnavailable = (type = 'downtime') => {
    isApiAvailable.value = false
    lastErrorTime.value = Date.now()
    errorType.value = type
  }

  const setApiAvailable = () => {
    isApiAvailable.value = true
    lastErrorTime.value = null
    errorType.value = null
  }

  const checkApiHealth = async () => {
    try {
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 5000)
      
      const response = await fetch(`${API_BASE_URL}/health`, {
        method: 'GET',
        credentials: 'include',
        signal: controller.signal
      })
      
      clearTimeout(timeoutId)
      
      if (response.ok) {
        setApiAvailable()
        return true
      }
      setApiUnavailable()
      return false
    } catch (error) {
      setApiUnavailable()
      return false
    }
  }

  return {
    isApiAvailable,
    lastErrorTime,
    errorType,
    setApiUnavailable,
    setApiAvailable,
    checkApiHealth
  }
}